export enum ErrorCode {
  AlreadyExists = 106,
  Forbidden = 403,
  NotFound = 404,
  InternalServerError = 500,
}
